import { skipToken, useQuery } from '@tanstack/react-query';
export function backerClaimConfirmationKey(network, marketAddress, walletAddress) {
    return ['backer-claim-confirmation', 'viewer', network, marketAddress ?? '', walletAddress ?? ''];
}
export function useBackerClaimAwaitingIndex(network, indexed) {
    const confirmation = useQuery({
        queryKey: backerClaimConfirmationKey(network, indexed?.marketAddress, indexed?.walletAddress),
        queryFn: skipToken,
        // A timer cannot prove that an indexed balance includes a confirmed burn.
        gcTime: indexed === undefined ? 0 : Infinity,
        staleTime: Infinity,
        meta: { persist: false },
    });
    return isBackerClaimAwaitingIndex(confirmation.data, indexed);
}
export function isBackerClaimAwaitingIndex(confirmation, indexed) {
    if (confirmation === undefined || indexed === undefined)
        return false;
    return (BigInt(indexed.userShareD6) > BigInt(confirmation.remainingShareD6) &&
        BigInt(indexed.claimedTotalD6) <= BigInt(confirmation.claimedTotalBeforeD6));
}
//# sourceMappingURL=backer-claim-confirmation.js.map